import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { useTheme } from "../utils/ThemeContext";
import { restrictedTrusteeTabs } from "./SidebarConstants";
const SidebarSubMenu = ({ item }) => {
  const { theme } = useTheme();

  const [subnav, setSubnav] = useState(false);
  const [white, setWhite] = useState();
  const [subwhite, setSubWhite] = useState();

  const location = useLocation();

  const showSubnav = () => {
    setSubnav(!subnav);
  };
  const duplicateUserRole =
    localStorage.getItem("duplicateRole") !== "undefined" &&
    JSON.parse(localStorage.getItem("duplicateRole"));
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const restrictedSubNavs = ["Client Contacts",];
  const hasPermission = (checkPermission = [], title) => {
    const availablePermissions =
      localStorage.getItem("permissionState") != "undefined" &&
      JSON.parse(localStorage.getItem("permissionState") || null);
      const userRoles = ["Financial Advisor", "Active Financial Advisor"]
    if (
      (userRoles.includes(duplicateUserRole )) &&
      restrictedSubNavs.includes(title)
    ) {
      return false;
    }else if(["protrustee","trustee"].includes(userRole) && restrictedTrusteeTabs.includes(title)){
      return false;
    }
    return checkPermission.some(
      (p) => availablePermissions && availablePermissions.includes(p)
    );
  };

  return (
    <>
      <Link
        to={item.path}
        onClick={() => {
          item.subNav && showSubnav();
        }}
        style={{
          pointerEvents: hasPermission(item.permission,item.title) ? "" : "none",
        }}
      >
        <div
          className={
            location.pathname == item.path
              ? `side-menu-block1-active`
              : `side-menu-block1`
          }
          // style={{cursor:"not-allowed", opacity:"0.5"}}
          onMouseLeave={() => setWhite("")}
          onMouseOver={() => {
            setWhite("white");
          }}
        >
          <div
            style={{
              cursor: hasPermission(item.permission,item.title) ? "" : "not-allowed",
              pointerEvents: hasPermission(item.permission,item.title) ? "" : "none",
              opacity: hasPermission(item.permission,item.title) ? "1" : "0.5",
            }}
          >
            <img
              src={item.whiteImage}
              className={
                white === "white" ||
                item.path == location.pathname ||
                theme === "dark"
                  ? "img-icon"
                  : "img-icon-dark"
              }
            />

            {/*  <img src={item.image} className="img-icon" /> */}
            <span
              style={{
                paddingLeft: "8px",
                color: theme === "dark" ? "white" : "",
              }}
              className=""
            >
              {item.title}
            </span>
          </div>
          {item.subNav && (
            <div className="">
              <Icon type="right" color={white} />
            </div>
          )}
        </div>
      </Link>
    </>
  );
};

export default SidebarSubMenu;
